export default "__VITE_ASSET__DZV5zzpB__"